module.exports = "https://cdn.hellotech.com/client-assets/hubs_and_speakers_tablet_d328db654041637614677f70af386d64.webp";